import React, { useState, useEffect } from "react";
import { StatsInvoice } from "../common/home/Stats";
import donasi from "../../assets/images/icon_donation/donation.svg";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { getDonations } from "../../core/service/api_donation";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { t } from "i18next";
import { BackButton } from "../common/BackButton";

const ComponentDonation = () => {
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  const goToDetail = async (data: any) => {
    navigate("/donation-detail", { state: { data: JSON.stringify(data) } });
  };
  useEffect(() => {
    dispatch(setLoading(true));
    getData(page, size)
  }, []);

  const getData = async (newPage: any, newSize: any) => {
    dispatch(setLoading(true));
    getDonations(newPage, newSize)
      .then((res: any) => {
        console.log(res);
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  }

  const changeSize = (newSize: any) => {
    setSize(newSize);
    getData(page, newSize)
  };

  const changePage = (newPage: any) => {
    setPage(newPage);
    getData(newPage, size)    
  };

  return (
    <div className="bg-psp-primary pb-20 font-montserrat">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full pt-3">
          <div className="flex">
            <BackButton />
            <span className="text-4xl font-semibold ml-2">
              {t("DONATION.title")}
            </span>
          </div>
          <div className="container-fluid w-full mt-4 py-3">
            {data.map((res: any, index: any) => {
              return (
                <div>
                  <div
                    onClick={() => goToDetail(res)}
                    key={index}
                    className="w-full rounded-xl shadow-md mb-4"
                  >
                    <div className="flex flex-row hover:bg-slate-100 rounded-xl cursor-pointer">
                      <div className="py-2 pl-2 mr-4">
                        <img src={donasi} alt="" className="w-16" />
                      </div>
                      <div className="mt-2">
                        <span className="text-xl">{res.title}</span>
                        <p className="text-slate-400">
                          {moment(res.createDate).format("DD MMMM YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex relative mt-10 justify-between">
            <div className="pt-2 w-1/4">
              <p>
                {t("OTHER.showing")} {page + 1} {t("OTHER.to")} {size}{" "}
                {t("OTHER.from")} {total} data
              </p>
            </div>
            <div className="w-auto">
              <div className="">
                <select
                  onChange={(value) => {
                    console.log(value.target.value)
                    changeSize(value.target.value);
                  }}
                  value={size}
                  className="py-2 border rounded-lg bg-white"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={1000}>1000</option>
                </select>
                <span className="ml-1">{t("OTHER.entry")}</span>
              </div>
            </div>
            <div className="flex w-1/4">
              <button
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                {t("OTHER.previous")}
              </button>
              <button
                onClick={() => {
                  console.log(page)
                  console.log(page + 1)
                  changePage(page + 1)
                }}
                disabled={(page + 1) * size >= total}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                {t("OTHER.next")}
              </button>
            </div>
          </div>
          {/* <div className="flex relative mt-10 justify-between">
            <div className="pt-2 w-1/4">
              <p>
                Showing {page + 1} to {size} of {total} entry
              </p>
            </div>
            <div className="w-auto">
              <div className="">
                <select
                  onChange={(value) => {
                    changeSize(value.target.value);
                  }}
                  value={size}
                  className="py-2 border rounded-lg bg-white"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={1000}>1000</option>
                </select>
                <span className="ml-1">entries per page</span>
              </div>
            </div>
            <div className="flex w-1/4">
              <button
                onClick={() => changePage(page - 1)}
                disabled={page === 0}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                Previous
              </button>
              <button
                onClick={() => changePage(page + 1)}
                disabled={(page + 1) * size > total}
                className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
              >
                Next
              </button>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ComponentDonation;
